import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useT } from "../../i18n";

interface ClientRow {
  id: string;
  email: string;
  name: string | null;
  employee_bracket: string | null;
  created_at: string;
}

export function Leads() {
  const { t, lang } = useT();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [clients, setClients] = useState<ClientRow[]>([]);

  useEffect(() => {
    fetch("/api/admin/leads")
      .then((r) => {
        if (r.status === 401) {
          navigate("/admin");
          return null;
        }
        return r.json() as Promise<{ clients?: ClientRow[] }>;
      })
      .then((d) => {
        if (d) setClients(d.clients ?? []);
      })
      .catch(() => {});
  }, [navigate]);

  const filtered = clients.filter((c) => {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    return (
      (c.name ?? "").toLowerCase().includes(q) ||
      c.email.toLowerCase().includes(q)
    );
  });

  return (
    <div className="panel wide">
      <span className="eyebrow">{t("adminTitle")}</span>
      <div className="row" style={{ marginBottom: 12 }}>
        <Link className="btn ghost btnlink" to="/admin">
          {t("viewSettings")}
        </Link>
      </div>
      <h2>{t("leadsTitle")}</h2>

      <input
        className="searchbox"
        placeholder={t("leadsSearchPlaceholder")}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      <table className="leadtable">
        <thead>
          <tr>
            <th>{t("leadsColName")}</th>
            <th>{t("leadsColEmployees")}</th>
            <th>{t("leadsColDate")}</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((c) => (
            <tr key={c.id} onClick={() => navigate(`/admin/clients/${c.id}`)}>
              <td>{c.name}</td>
              <td>{c.employee_bracket}</td>
              <td>
                {new Intl.DateTimeFormat(lang === "pt" ? "pt-BR" : "en-US", {
                  dateStyle: "short",
                }).format(new Date(c.created_at))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
